import { render, staticRenderFns } from "./ProcessDownline.vue?vue&type=template&id=0051bac6&"
import script from "./ProcessDownline.vue?vue&type=script&lang=js&"
export * from "./ProcessDownline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports